<template>
  <v-container class="container--large" fluid>
    <v-alert
      v-if="hasAlertModal"
      dense
      type="error"
      dismissible
      transition="slide-y-transition"
    >
      Video Not Found
    </v-alert>
    <div class="header-title">
      <header-title-one title="Welcome to Green Street’s Learning Center" />
      <HomeSupportAssistance />
    </div>
    <div class="home-content">
      <router-view />
      <div v-if="windowWidth <= 1263">
        <HomeGoToResources />
      </div>

      <div class="home-content__videos">
        <HomeVideoTutorials />
      </div>

      <div class="home-content__main">
        <HomeGoToResources v-if="windowWidth > 1263" />
        <HomeLive101Trainings v-if="windowWidth > 1263"/>
        <HomeMethodology />
        <HomeFoundationalReports />
      </div>

      <div class="home-content__guides">
        <HomeHelpfulHints />
        <HomeSectorPrimers />
        <HomeTechnicalGuides />
      </div>
    </div>
  </v-container>
</template>

<script>
import HeaderTitleOne from '../../components/typography/header-title-1.vue';
import HomeGoToResources from './HomeGoToResources.vue';
import HomeVideoTutorials from './HomeVideoTutorials.vue';
import HomeLive101Trainings from './HomeLive101Trainings.vue';
import HomeMethodology from './HomeMethodology.vue';
import HomeFoundationalReports from './HomeFoundationalReports.vue';
import HomeHelpfulHints from './HomeHelpfulHints.vue';
import HomeTechnicalGuides from './HomeTechnicalGuides.vue';
import HomeSupportAssistance from './HomeSupportAssistance.vue';
import HomeSectorPrimers from './HomeSectorPrimers.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    HeaderTitleOne,
    HomeGoToResources,
    HomeVideoTutorials,
    HomeLive101Trainings,
    HomeMethodology,
    HomeFoundationalReports,
    HomeHelpfulHints,
    HomeTechnicalGuides,
    HomeSupportAssistance,
    HomeSectorPrimers,
  },
  computed: {
    ...mapGetters(['windowWidth']),
  },
  watch: {
    '$route.query.video'() {
      this.handleQueryVideo();
    },
    hasAlertModal() {
      if (this.hasAlertModal) {
        setTimeout(() => {
          this.hasAlertModal = false;
        }, 2000)
      }
    }
  },
  data: () => ({
    hasAlertModal: false,
    hasVideoAlertModal: false,
  }),
  mounted() {
    this.handleQueryVideo();
  },
  methods: {
    handleQueryVideo() {
      if (this.$route.query.video) {
        this.hasVideoAlertModal = true;
        this.hasAlertModal = true;
        window.history.pushState({}, document.title, window.location.pathname);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header-title {
  padding-top: 42px;
  padding-bottom: 54px;
  @media (max-width: 1263px) {
    padding-bottom: 32px;
    padding-top: 16px;
  }
}
.home-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 2rem;

  @media (max-width: 1263px) {
    flex-direction: column;
  }
  &__videos {
    max-width: 446px;
    width: 100%;
    margin-right: 16px;
    @media (max-width: 1315px) {
      max-width: 385px;
    }
    @media (max-width: 1263px) {
      max-width: initial;
      margin-right: 0;
    }
  }
  &__main {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    row-gap: 2rem;

    @media (max-width: 1263px) {
      overflow: initial;
      flex: initial;
      width: 100%;
      max-width: initial;
      margin-right: 0;
    }
    @media (min-width: 1263px) {
      justify-content: space-between;
    }
  }
  &__guides, &__guides-row {
    display: flex;
    row-gap: 2rem;
  }
  &__guides {
    flex-direction: column;
    width: 100%;
  }
  &__guides-row {
    column-gap: 0.5rem;
    flex-direction: column;
    @media (min-width: 1263px) {
      flex-direction: row;
      align-items: flex-start;
    }
  }
}
</style>
<style scoped>
  .header-title {
    display: grid;
    row-gap: 16px;
  }
  @media screen and (min-width: 1263px) { 
    .header-title {
      grid-template-columns: 34% 66%;
    }
  }
  .home-content__guides >>> .header-title-two > .col,
  .home-content__main >>> .header-title-two > .col,
  .home-content__videos >>> .header-title-two > .col,
  .home-content .resources-and-support >>> .header-title-two > .col {
    padding-bottom: unset;
  }
  .home-content__guides /deep/ > div:not(:last-child) > div:nth-child(1),
  .home-content__main /deep/ > div > div:nth-child(1),
  .home-content__guides-row /deep/ > div > div:nth-child(1) {
    display: flex;
    align-items: center;
  }
</style>
